"use client";

import { ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OrganizationalServicesGrid() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const disciplines = [{
    number: "01",
    title: "Profil & Konstitusi",
    description: "Menyajikan landasan ideologis, sejarah pembentukan, serta konstitusi yang menjadi pedoman utama organisasi dalam menjalankan visi nasional.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/profil_konstitusi.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/profil_konstitusi.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/profil_konstitusi.png-wvc-sizes",
    alt: "Dokumen konstitusi dan lambang organisasi"
  }, {
    number: "02",
    title: "Mandat & Komando",
    description: "Informasi mengenai garis instruksi, kebijakan strategis, dan komando pusat yang menggerakkan seluruh elemen organisasi di tingkat nasional.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/mandat_komando.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/mandat_komando.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/mandat_komando.webp-wvc-sizes",
    alt: "Rapat koordinasi pimpinan organisasi"
  }, {
    number: "03",
    title: "Hierarki Teritori",
    description: "Pemetaan struktur organisasi yang tersebar di seluruh wilayah Indonesia, memastikan koordinasi yang solid dari pusat hingga ke daerah.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/hierarki_teritori.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/hierarki_teritori.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/hierarki_teritori.png-wvc-sizes",
    alt: "Peta wilayah operasional organisasi"
  }];
  return <section data-section-id="2840" id="organizationalservicesgrid" className="bg-white text-black py-32 md:py-40 lg:py-[10rem] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-[60%_40%] gap-10 lg:gap-16 mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div>
            <p className="font-default text-[11px] tracking-[0.25em] uppercase mb-8 md:mb-10" style={{
            color: "var(--primary)"
          }}>
              Zona Pemuda Pancasila — 02
            </p>
            <h2 className="font-default text-5xl md:text-6xl lg:text-[5rem] leading-[1.05] tracking-tight text-black">
              Struktur Organisasi.
              <br />
              Satu{" "}
              <em className="italic font-light" style={{
              color: "var(--primary)"
            }}>
                Komando
              </em>
              .
            </h2>
          </div>
          <div className="flex items-end">
            <p className="font-default text-base md:text-[15px] leading-[1.7] max-w-md" style={{
            color: "var(--muted-foreground)"
          }}>
              ABADI.NEWS menghadirkan informasi mendalam mengenai struktur, konstitusi, dan pergerakan organisasi Pemuda Pancasila. Tiga pilar utama yang menjaga integritas dan semangat nasionalisme di seluruh pelosok negeri.
            </p>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 transition-all duration-1000 ease-out delay-200 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {disciplines.map((item, i) => <article data-index={i} key={item.number} className="group relative aspect-[4/5] overflow-hidden border border-gray-200 hover:border-orange-500 transition-all duration-700 cursor-pointer rounded-lg">
              {}
              <div className="absolute inset-0 overflow-hidden">
                <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-105" />
                {}
                <div className="absolute inset-0 transition-opacity duration-700" style={{
              background: "linear-gradient(180deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.5) 60%, rgba(0,0,0,0.8) 100%)"
            }} />
              </div>

              {}
              <div className="absolute top-8 left-8 md:top-10 md:left-10 z-10">
                <span className="font-default text-[11px] tracking-[0.25em] text-orange-500">
                  {item.number}
                </span>
              </div>

              {}
              <div className="absolute bottom-8 right-8 md:bottom-10 md:right-10 z-10 transition-transform duration-500 group-hover:translate-x-1">
                <ChevronRight className="w-5 h-5 text-orange-500" strokeWidth={2} />
              </div>

              {}
              <div className="absolute bottom-8 left-8 md:bottom-10 md:left-10 right-16 md:right-20 z-10">
                <h3 className="font-default text-2xl md:text-3xl lg:text-[2rem] leading-tight text-white transition-transform duration-500 ease-out md:group-hover:-translate-y-2" style={{
              fontWeight: 600
            }}>
                  {item.title}
                </h3>
                <p className="font-default text-sm leading-[1.65] mt-4 md:mt-0 md:opacity-0 md:max-h-0 md:overflow-hidden md:group-hover:opacity-100 md:group-hover:max-h-40 md:group-hover:mt-4 transition-all duration-500 ease-out text-gray-200">
                  {item.description}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}